import React from "react";
// React Router
import { useHistory, useParams } from "react-router-dom";
// Styled Components
import styled from "styled-components";
// Components
import VerticalCard from "../generic/VerticalCard";

const CardComunidad = styled(VerticalCard).attrs(props => ({

  grayscale: props.active ? 0 : 100,
  shadow: props.active ? "0 0px 6px #2a599f !important" : "0 0px 6px #93a1b4 !important",
  backgroundColor: props.eliminaComunidadNueva ? "#C7FF00" : '#ffffff',

}))`
background-color: ${props => props.backgroundColor};
-webkit-filter: grayscale(${props => props.grayscale}); /* Safari 6.0 - 9.0 */
filter: grayscale(${props => props.grayscale});

  :hover {
    box-shadow: 0 0px 6px #2a599f !important;
  }
`;

const ComunidadTarjeta = ({ content, ...props }) => {
  let history = useHistory();

  let { id_p } = useParams()
  let provinciaId = id_p ? id_p : '14';

  let defaultImg = "/images/logoSTJ.png";
  let img = content.photo ? `${process.env.REACT_APP_API_URL}/download/provincias/${content.provinceId}/comunidades/${content.id}` : `/images/provincias/${provinciaId}.png`;


  return (
    <>
    {
    //console.log(`${process.env.REACT_APP_API_URL}/download/provincias/${content.provinceId}/comunidades/${content.id}`)
    }
      <CardComunidad
        onClick={(e) => {
          history.push(`comunidades/${content.id}`);
        }}
        cardImage={img}
        title={content.name}
        imgOnError={defaultImg}
        ciudad={content.city}
        pais={content.country}
        active={!content.endDate}
        eliminaComunidadNueva={content.name === '- Edite la NUEVA comunidad -' ? true : false}
        idComunidad={content.id}
        {...props}
        
      />
    </>
  );
};

export default ComunidadTarjeta;
